import { colors } from '../sharedStyles';

export default function Footer({ scrollToSection }) {
    return (
        <footer style={{ color: colors.white, padding: '4rem 1.5rem', backgroundColor: colors.primary }}>
            <div style={{ maxWidth: '72rem', margin: '0 auto', textAlign: 'center' }}>

                {/* Contact Info */}
                <div style={{ marginBottom: '2rem' }}>
                    <p style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '0.5rem', color: colors.white }}>CONTACT</p>
                    <p style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>
                        <a href="tel:+33649252592" style={{ color: colors.white, textDecoration: 'none' }}>06 49 25 25 92</a>
                    </p>
                    <p style={{ fontSize: '1.1rem' }}>
                        <a href="mailto:lequipierfinance@proton.me" style={{ color: colors.white, textDecoration: 'none' }}>lequipierfinance@proton.me</a>
                    </p>
                </div>

                {/* LinkedIn Button */}
                <div style={{ marginBottom: '3rem' }}>
                    <a
                        href="https://www.linkedin.com/in/fabien-noel/"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.75rem',
                            backgroundColor: '#0077b5',
                            color: 'white',
                            padding: '0.75rem 1.5rem',
                            borderRadius: '50px',
                            textDecoration: 'none',
                            fontWeight: 600,
                            transition: 'transform 0.2s'
                        }}
                        onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                        onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                        </svg>
                        Me suivre sur LinkedIn
                    </a>
                </div>

                {/* Tagline */}
                {/* <div style={{ borderTop: `1px solid rgba(255, 255, 255, 0.1)`, maxWidth: '40rem', margin: '0 auto 2rem auto', paddingTop: '2rem' }}>
                    <p style={{ fontStyle: 'italic', color: 'rgba(255, 255, 255, 0.8)', fontSize: '1rem', lineHeight: 1.6 }}>
                        "Basé en Auvergne, j'interviens partout en France pour structurer votre réussite."
                    </p>
                </div> */}

                {/* Legal & Copyright */}
                <div style={{ fontSize: '0.875rem', color: 'rgba(255, 255, 255, 0.5)', display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap' }}>
                    {/* <a href="#" style={{ color: 'inherit', textDecoration: 'none' }}>Mentions légales</a>
                    <a href="#" style={{ color: 'inherit', textDecoration: 'none' }}>Confidentialité</a> */}
                    <span>&copy; {new Date().getFullYear()} L'équipier Finance</span>
                </div>
            </div>
        </footer>
    );
}
